<template>
  <div class="contact-container">
    <div class="title">{{ contactInfo.name }}</div>
    <div class="tel">电话：{{ contactInfo.phone }}</div>
    <div class="tel">邮箱：{{ contactInfo.email }}</div>
    <div class="map-container" id="container" style="width: 1200px; height: 617px"></div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { getContact } from "@/api/common";
export default {
  name: "Contact",
  components: {},
  data() {
    return {
      contactInfo: {},
    };
  },

  mounted() {
    getContact().then((res) => {
      if (res.code == 1) {
        this.contactInfo = res.obj;
        this.$nextTick(() => {
          this.initAMap();
        });
      }
    });
  },

  beforeDestroy() {
    this.map?.destroy();
  },
  methods: {
    initAMap() {
      AMapLoader.load({
        key: "67cf15a614d907f427ecf4327e2f9f09", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "3D", // 是否为3D地图模式
            zoom: 13, // 初始化地图级别
            center: [this.contactInfo.lng, this.contactInfo.lat], // 初始化地图中心点位置
          });
          // 点标记显示内容，HTML要素字符串
          var markerContent =
            "" +
            '<div class="custom-content-marker">' +
            '   <img style="width: 38px" src="//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png">' +
            `<div style="margin-left:30px;margin-top:-15px;font-size: 16px;color: #333333;width: 314px;background: #ffffff;border-radius: 10px;box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.10); padding:14px 18px">${this.contactInfo.address}</div>` +
            "</div>";
          var position = new AMap.LngLat(this.contactInfo.lng, this.contactInfo.lat);
          var marker = new AMap.Marker({
            position: position,
            // 将 html 传给 content
            content: markerContent,
            // 以 icon 的 [center bottom] 为原点
            offset: new AMap.Pixel(-13, -30),
          });

          // 将 markers 添加到地图
          this.map.add(marker);
        })
        .catch((e) => {
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
